<template>
    <form @submit.prevent="handleLoginForm">  
        <label>Gebruikersnaam</label>
        <input type="username" placeholder="Uw gebruikersnaam / email" required v-model="username">
        <div class="error" v-if="invalidName">{{ invalidName }}</div>
        <label>Wachtwoord</label>
        <input type="password" placeholder="Uw wachtwoord" required v-model="password">
        <div class="submit">
            <button>Aanmelden</button>
        </div>
    </form>
</template>

<script>
export default {
   data() {
       return {
           username: '',
           password: '',
           invalidName: ''
       } 
    },
    methods: {
        handleLoginForm() {
          console.log("handleLoginForm (LoginForm.vue): " +  this.username + "|" +  this.password);
            const options = {};
            options["username"] = this.username
            options["password"] = this.password
            this.$store.dispatch('login', options)

        }
    }
}
</script>